import React from 'react'
import { Grid, Menu, MenuItem, withStyles, ListItemIcon, ListItemText } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AddCommentIcon from '@material-ui/icons/AddComment'
import AddIcon from '@material-ui/icons/Add'
import PhotoIcon from '@material-ui/icons/Photo'
import EditIcon from '@material-ui/icons/Edit'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import { useAuth } from 'hooks/useAuth'
import { CustomButton } from 'components'
import { useStyles } from './MenuAcoes.styles'
import { useCallback } from 'react'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const { idPericiando, id_caso } = props
  const classes = useStyles()
  const router = useRouter()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = React.useState(false)
  const { currentUser } = useAuth()

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
  }

  const handleClickAdicionarInformacao = useCallback(() => {
    router.history.push(`/periciando/adicionarInformacao/${idPericiando}`)
  }, [])

  return (
    <Grid alignItems="center" justifyContent="flex-end" container spacing={1}>
      <Grid item>
        <CustomButton aria-controls="customized-menu" aria-haspopup="true" onClick={handleClickBotaoAcoes} endIcon={<ArrowDropDownIcon />} colorType="primary">
          Ações
        </CustomButton>
        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <>
            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/editarpericiando/${idPericiando}`)}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Editar Periciando" />
            </StyledMenuItem>

            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/casos/caso/periciando/extrair/${idPericiando}`)}>
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Extrair vestígio" />
            </StyledMenuItem>
            <StyledMenuItem onClick={handleClickAdicionarInformacao}>
              <ListItemIcon>
                <AddCommentIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Adicionar Informação</ListItemText>
            </StyledMenuItem>
            <StyledMenuItem onClick={() => router.history.push(`/galeria/periciando/${idPericiando}`)}>
              <ListItemIcon>
                <PhotoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Ver galeria" />
            </StyledMenuItem>

            {currentUser.cargo.id === 1 && (
              <StyledMenuItem onClick={() => setIsGerenciarAcessoOpen(true)}>
                <ListItemIcon>
                  <SupervisedUserCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Conceder acesso à galeria" />
              </StyledMenuItem>
            )}
          </>
        </StyledMenu>
      </Grid>
      <ModalGerenciarAcesso open={isGerenciarAcessoOpen} onClose={() => setIsGerenciarAcessoOpen(false)} idCaso={id_caso} usuarios={[]} selecionados={[]} />
    </Grid>
  )
}
